import type { QueryKey } from '@tanstack/react-query';

/** Centralized React Query keys for course appearance data. */
export const appearanceKeys = {
  sections: (productId: string): QueryKey => [
    'appearance',
    'page-sections',
    productId,
  ],
  menuItems: (productId: string): QueryKey => [
    'appearance',
    'menu-items',
    productId,
  ],
};
